import { apiFetch } from './apiClient';



export async function buscarLogs({ page = 1, limite = 100, modulo, acao, data_inicio, data_fim } = {}) {
  const params = new URLSearchParams({ page, limite });
  if (modulo)      params.set('modulo', modulo);
  if (acao)        params.set('acao', acao);
  if (data_inicio) params.set('data_inicio', data_inicio);
  if (data_fim)    params.set('data_fim', data_fim + 'T23:59:59');
  return apiFetch(`/auditoria/logs?${params}`);
}

/* Envia evento manual do frontend (navegação, login, logout) — fire-and-forget */
export function registrarAcao(acao, modulo, detalhes = {}) {
  apiFetch('/auditoria/log', {
    method: 'POST',
    body: JSON.stringify({ acao, modulo, detalhes }),
  }).catch(() => {});
}
